import { render, staticRenderFns } from "./QAvatar.vue?vue&type=template&id=5aca3ad5&scoped=true"
import script from "./QAvatar.vue?vue&type=script&lang=js"
export * from "./QAvatar.vue?vue&type=script&lang=js"
import style0 from "./QAvatar.vue?vue&type=style&index=0&id=5aca3ad5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aca3ad5",
  null
  
)

/* custom blocks */
import block0 from "./QAvatar.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports